import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Table from '@chama/ui-components/components/Table';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
};

const NearbyDealerTable = ({ children }) => {
  return (
    <Table>
      <Table.Header>
        <Table.Row>
          <Table.Cell>
            <FormattedMessage id="name.uppercase" defaultMessage="NAME" />
          </Table.Cell>
          <Table.Cell>
            <FormattedMessage id="brand.uppercase" defaultMessage="BRAND" />
          </Table.Cell>
          <Table.Cell>
            <FormattedMessage id="phone.uppercase" defaultMessage="PHONE" />
          </Table.Cell>
          <Table.Cell>
            <span>RATING</span>
          </Table.Cell>
          <Table.Cell>
            <FormattedMessage id="price.uppercase" defaultMessage="PRICE" />
          </Table.Cell>
          <Table.Cell>
            <FormattedMessage id="eta.uppercase" defaultMessage="ETA" />
          </Table.Cell>
          <Table.Cell>
            <FormattedMessage id="office_hours.uppercase" defaultMessage="OFFICE HOURS" />
          </Table.Cell>
          <Table.Cell>
            <span>STATUS</span>
          </Table.Cell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{children}</Table.Body>
    </Table>
  );
};

NearbyDealerTable.propTypes = propTypes;

export default NearbyDealerTable;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderDetailsLayout/DealersNearbyList/NearbyDealerTable.jsx